/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class AppraisalRule extends Sv {
    constructor() {
        super();
        this.baseUrl += '/appraisalRule';
    }

    data({
        appraisalRuleName,
        appraisalSubject,
        classExaminationType,
        isAvailable,
        schoolOrgId,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            appraisalRuleName,
            appraisalSubject,
            classExaminationType,
            isAvailable,
            schoolOrgId,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({
        id,
        appraisalRuleName,
        appraisalSubject,
        classExaminationType,
        isAvailable,
        schoolOrgId,
        ruleScoreListJsonStr,
        ruleMakeUpListJsonStr,
        certificationAuthority,
        examSite,
        trainingSite,
        minManAge,
        maxManAge,
        minWomenAge,
        maxWomenAge,
    } = {}) {
        return super.post('/save', {
            id,
            appraisalRuleName,
            appraisalSubject,
            classExaminationType,
            isAvailable,
            schoolOrgId,
            ruleScoreListJsonStr,
            ruleMakeUpListJsonStr,
            certificationAuthority,
            examSite,
            trainingSite,
            minManAge,
            maxManAge,
            minWomenAge,
            maxWomenAge,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    validatorAppraisalRuleName({ id, appraisalRuleName } = {}) {
        return super.get('/validatorAppraisalRuleName', {
            id,
            appraisalRuleName,
        });
    }
}

export default new AppraisalRule();
export { AppraisalRule };
